export default class ProtocolContent {
    type;
    data;
    constructor(protocolContent = {}) {
        Object.assign(this, protocolContent);
    }
}
//# sourceMappingURL=ProtocolContent.js.map